var _excluded = ["separatorMode", "className", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo } from 'react';
import { RightOutlined } from '@aelf-design/icons';
import { Breadcrumb as AntdBreadcrumb } from 'antd';
import classNames from 'classnames';
import useStyles from "./style";
var Breadcrumb = function Breadcrumb(props) {
  var separatorMode = props.separatorMode,
    className = props.className,
    size = props.size,
    resetProps = _objectWithoutProperties(props, _excluded);
  var _useStyles = useStyles(props),
    styles = _useStyles.styles;
  var cls = classNames(className, styles.breadcrumbWrap);
  var separatorProps = useMemo(function () {
    if (separatorMode === 'arrow') {
      return {
        separator: /*#__PURE__*/React.createElement(RightOutlined, null)
      };
    }
    return {};
  }, [separatorMode]);
  return /*#__PURE__*/React.createElement(AntdBreadcrumb, _extends({}, separatorProps, resetProps, {
    className: cls
  }));
};
Breadcrumb.Item = AntdBreadcrumb.Item;
Breadcrumb.Separator = AntdBreadcrumb.Separator;
Breadcrumb.displayName = 'AelfBreadcrumb';
export default Breadcrumb;